import { Box } from '@mui/material';

interface StatusDotProps {
  /** Green reads "live, listening"; orange reads "degraded". */
  color: string;
  size?: number;
}

/**
 * A slow pulse that tells the driver the screen is still listening.
 *
 * The station page spends most of its life waiting on someone else — the
 * charger, the socket — with nothing on screen moving. The same dot carries
 * that in both places it happens, so "something is still happening" is one
 * visual idea rather than two unrelated ones.
 */
export const StatusDot: React.FC<StatusDotProps> = ({ color, size = 8 }) => (
  <Box
    aria-hidden
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor: color,
      flexShrink: 0,
      animation: 'stationStatusPulse 1.4s ease-in-out infinite',
      '@keyframes stationStatusPulse': {
        '0%, 100%': { opacity: 0.35 },
        '50%': { opacity: 1 },
      },
      '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        opacity: 0.9,
      },
    }}
  />
);
